import React from 'react';
import { FooterContent } from './FooterElements';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks';
import { usePrivacyConsent } from '../../privacy/PrivacyConsent';

const copy = {
  ru: { policy: 'Политика конфиденциальности', settings: 'Настройки конфиденциальности' },
  md: { policy: 'Politica de confidențialitate', settings: 'Preferințe de confidențialitate' },
  en: { policy: 'Privacy policy', settings: 'Privacy preferences' },
};

const Footer = () => {
  const { lang } = useLanguage();
  const { openPreferences } = usePrivacyConsent();
  const text = copy[lang] || copy.md;

  return (
    <FooterContent>
      <span>Vipropat 2005-2026. ALL RIGHTS RESERVED.</span>
      <div>
        <Link to="/privacy">{text.policy}</Link>
        <button type="button" onClick={openPreferences}>
          {text.settings}
        </button>
      </div>
    </FooterContent>
  );
};

export default Footer;
